module.exports = __webpack_public_path__ + "4035aab50ab7cbef347a911521c73925.png";